import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const AdminQuotes = () => {
  const navigate = useNavigate();
  const [quotes, setQuotes] = useState([]);
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  // 今日の一言 一覧を取得
  const fetchQuotes = async () => {
    try {
      const res = await api.get('/api/quotes/');
      setQuotes(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error('今日の一言の取得エラー:', error);
      setMessage('一覧の取得に失敗しました。');
      setIsError(true);
    }
  };

  useEffect(() => {
    fetchQuotes();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
    setMessage('');
    setIsError(false);
  };

  // CSV を Django Backend に送信
  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage('CSVファイルを選択してください。');
      setIsError(true);
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await api.post('/api/quotes/import/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const errs = Array.isArray(res.data?.errors) ? res.data.errors : [];
      setMessage(
        (res.data?.message || 'インポートしました。') +
          (errs.length ? `（${errs.length}件スキップ）` : '')
      );
      setIsError(false);
      fetchQuotes();
    } catch (error) {
      const detail = error?.response?.data?.message || error?.response?.data?.detail;
      setMessage(detail || 'CSVのアップロードに失敗しました。ファイル形式・文字コードを確認してください。');
      setIsError(true);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: 900, margin: '0 auto', fontFamily: 'inherit' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        <button
          type="button"
          onClick={() => navigate(-1)}
          style={{ padding: '6px 12px', border: '1px solid #cbd5e1', borderRadius: 8, background: '#fff', cursor: 'pointer' }}
        >
          ← 戻る
        </button>
        <h2 style={{ margin: 0 }}>今日の一言</h2>
      </div>

      <p style={{ fontSize: '0.85rem', color: '#475569', lineHeight: 1.6 }}>
        CSV形式：1列目=公開日（例 <code>2026-07-16</code>）、2列目=内容。ヘッダー行があっても取り込めます。
        文字コードは UTF-8 / Shift-JIS(Excel) の両方に対応。同じ公開日は上書き更新されます。
      </p>

      <form onSubmit={handleUpload} style={{ margin: '12px 0 20px' }}>
        <input type="file" accept=".csv" onChange={handleFileChange} />
        <button
          type="submit"
          style={{ marginLeft: '10px', padding: '6px 16px', background: '#2c5282', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
        >
          Import CSV
        </button>
      </form>

      {message && (
        <p style={{ color: isError ? '#dc2626' : '#16a34a', fontWeight: 600 }}>{message}</p>
      )}

      <table border="1" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '16px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f2f2f2' }}>
            <th style={{ padding: '10px', width: '30%', textAlign: 'left' }}>公開日</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>内容</th>
          </tr>
        </thead>
        <tbody>
          {quotes.length > 0 ? (
            quotes.map((quote, index) => (
              <tr key={index}>
                <td style={{ padding: '10px', whiteSpace: 'nowrap' }}>{quote.publish_date}</td>
                <td style={{ padding: '10px' }}>{quote.content}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={2} style={{ padding: '16px', textAlign: 'center', color: '#6b7280' }}>
                まだ登録されていません。
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AdminQuotes;
